
export class ConfigModel {
	ehs_CurrentYear: number;
	ehs_Injury_Max: number;
	ehs_Injury_Yellow: number;
	ehs_Injury_Orange: number;
	ehs_Injury_CurrentYearValue: number;
	ehs_Injury_LastYearValue: number;
	ehs_Injury_Text: string;
	ehs_InjuryDays_Value: number;
	ehs_InjuryDays_TextExplanation: string;
	ehs_InjuryDays_TextPerformance: string;
	ehs_Process_Max: number;
	ehs_Process_Orange: number;
	ehs_Process_Yellow: number;
	ehs_Process_CurrentYearValue: number;
	ehs_Process_LastYearValue: number;
	ehs_Process_Text: string;

	ehs_Injury_CurrentYearValue_Offshore: number;
	ehs_Injury_LastYearValue_Offshore: number;
	ehs_InjuryDays_LastDate_Offshore: Date = new Date();
	ehs_InjuryDays_BestPerformanceOffshore: number;
	ehs_Process_CurrentYearValue_Offshore: number;
	ehs_Process_LastYearValue_Offshore: number;

	ops_CurrentMonth: number;
	ops_CurrentMonthName: string;
	ops_CurrentYear: number;

	ops_ProdArea_OnshoreEA: number;
	ops_ProdArea_OffshoreWA: number;
	ops_ProdArea_OffshoreNA: number;
	ops_ProdArea_PNG: number;
	ops_ProdArea_Max: number;

	ops_ProdType_Domgas: number;
	ops_ProdType_Liquids: number;
	ops_ProdType_LNG: number;
	ops_ProdType_Max: number;

	ops_Drilled_Cooper_Target: number;
	ops_Drilled_Cooper_LastYear: number;
	ops_Drilled_Cooper_Jan: number;
	ops_Drilled_Cooper_Feb: number;
	ops_Drilled_Cooper_Mar: number;
	ops_Drilled_Cooper_Apr: number;
	ops_Drilled_Cooper_May: number;
	ops_Drilled_Cooper_Jun: number;
	ops_Drilled_Cooper_Jul: number;
	ops_Drilled_Cooper_Aug: number;
	ops_Drilled_Cooper_Sep: number;
	ops_Drilled_Cooper_Oct: number;
	ops_Drilled_Cooper_Nov: number;
	ops_Drilled_Cooper_Dec: number;
	ops_Drilled_GLNG_Target: number;
	ops_Drilled_GLNG_LastYear: number;
	ops_Drilled_GLNG_Jan: number;
	ops_Drilled_GLNG_Feb: number;
	ops_Drilled_GLNG_Mar: number;
	ops_Drilled_GLNG_Apr: number;
	ops_Drilled_GLNG_May: number;
	ops_Drilled_GLNG_Jun: number;
	ops_Drilled_GLNG_Jul: number;
	ops_Drilled_GLNG_Aug: number;
	ops_Drilled_GLNG_Sep: number;
	ops_Drilled_GLNG_Oct: number;
	ops_Drilled_GLNG_Nov: number;
	ops_Drilled_GLNG_Dec: number;
	ops_Drilled_Max: number;
	ops_Drilled_SubHeading: string;

	fin_Revenue_Name1: string;
	fin_Revenue_Name2: string;
	fin_Revenue_Name3: string;
	fin_Revenue_Name4: string;
	fin_Revenue_1: number;
	fin_Revenue_2: number;
	fin_Revenue_3: number;
	fin_Revenue_4: number;
	fin_Revenue_Max: number;

	fin_Cost_Name1: string;
	fin_Cost_Name2: string;
	fin_Cost_Name3: string;
	fin_Cost_Name4: string;
	fin_Cost_1: number;
	fin_Cost_2: number;
	fin_Cost_3: number;
	fin_Cost_4: number;
	fin_Cost_Max: number;

	fin_Cash_Name1: string;
	fin_Cash_Name2: string;
	fin_Cash_Name3: string;
	fin_Cash_Name4: string;
	fin_Cash_1: number;
	fin_Cash_2: number;
	fin_Cash_3: number;
	fin_Cash_4: number;
	fin_Cash_Max: number;

	fin_Gearing_Name1: string;
	fin_Gearing_Name2: string;
	fin_Gearing_Name3: string;
	fin_Gearing_Name4: string;
	fin_Gearing_1: number;
	fin_Gearing_2: number;
	fin_Gearing_3: number;
	fin_Gearing_4: number;
	fin_Gearing_Max: number;

	constructor() {
		this.ehs_CurrentYear = 2000;
		this.ehs_Injury_Max = 0;
		this.ehs_Injury_Yellow = 0;
		this.ehs_Injury_Orange = 0;
		this.ehs_Injury_CurrentYearValue = 0;
		this.ehs_Injury_LastYearValue = 0;
		this.ehs_Injury_Text = '';
		this.ehs_InjuryDays_Value = 0;
		this.ehs_InjuryDays_TextExplanation = '';
		this.ehs_InjuryDays_TextPerformance = '';
		this.ehs_Process_Max = 0;
		this.ehs_Process_Orange = 0;
		this.ehs_Process_CurrentYearValue = 0;
		this.ehs_Process_LastYearValue = 0;
		this.ehs_Process_Text = '';
		this.ehs_InjuryDays_LastDate_Offshore = new Date();

		this.ops_CurrentMonth = 1;
		this.ops_CurrentMonthName = '';
		this.ops_CurrentYear = 2000;
		this.ops_ProdArea_OnshoreEA = 0;
		this.ops_ProdArea_OffshoreWA = 0;
		this.ops_ProdArea_OffshoreNA = 0;
		this.ops_ProdArea_PNG = 0;
		this.ops_ProdArea_Max = 0;
		this.ops_ProdType_Domgas = 0;
		this.ops_ProdType_Liquids = 0;
		this.ops_ProdType_LNG = 0;

		this.ops_ProdType_Max = 0;
		this.ops_Drilled_Cooper_Target = 0;
		this.ops_Drilled_Cooper_LastYear = 0;
		this.ops_Drilled_Cooper_Jan = 0;
		this.ops_Drilled_Cooper_Feb = 0;
		this.ops_Drilled_Cooper_Mar = 0;
		this.ops_Drilled_Cooper_Apr = 0;
		this.ops_Drilled_Cooper_May = 0;
		this.ops_Drilled_Cooper_Jun = 0;
		this.ops_Drilled_Cooper_Jul = 0;
		this.ops_Drilled_Cooper_Aug = 0;
		this.ops_Drilled_Cooper_Sep = 0;
		this.ops_Drilled_Cooper_Oct = 0;
		this.ops_Drilled_Cooper_Nov = 0;
		this.ops_Drilled_Cooper_Dec = 0;
		this.ops_Drilled_GLNG_Target = 0;
		this.ops_Drilled_GLNG_LastYear = 0;
		this.ops_Drilled_GLNG_Jan = 0;
		this.ops_Drilled_GLNG_Feb = 0;
		this.ops_Drilled_GLNG_Mar = 0;
		this.ops_Drilled_GLNG_Apr = 0;
		this.ops_Drilled_GLNG_May = 0;
		this.ops_Drilled_GLNG_Jun = 0;
		this.ops_Drilled_GLNG_Jul = 0;
		this.ops_Drilled_GLNG_Aug = 0;
		this.ops_Drilled_GLNG_Sep = 0;
		this.ops_Drilled_GLNG_Oct = 0;
		this.ops_Drilled_GLNG_Nov = 0;
		this.ops_Drilled_GLNG_Dec = 0;
		this.ops_Drilled_Max = 0;

		this.fin_Revenue_Name1 = '';
		this.fin_Revenue_Name2 = '';
		this.fin_Revenue_Name3 = '';
		this.fin_Revenue_Name4 = '';
		this.fin_Cost_Name1 = '';
		this.fin_Cost_Name2 = '';
		this.fin_Cost_Name3 = '';
		this.fin_Cost_Name4 = '';
		this.fin_Cash_Name1 = '';
		this.fin_Cash_Name2 = '';
		this.fin_Cash_Name3 = '';
		this.fin_Cash_Name4 = '';
		this.fin_Gearing_Name1 = '';
		this.fin_Gearing_Name2 = '';
		this.fin_Gearing_Name3 = '';
		this.fin_Gearing_Name4 = '';

		this.fin_Revenue_1 = 0;
		this.fin_Revenue_2 = 0;
		this.fin_Revenue_3 = 0;
		this.fin_Revenue_4 = 0;
		this.fin_Revenue_Max = 0;
		this.fin_Cost_1 = 0;
		this.fin_Cost_2 = 0;
		this.fin_Cost_3 = 0;
		this.fin_Cost_4 = 0;
		this.fin_Cost_Max = 0;
		this.fin_Cash_1 = 0;
		this.fin_Cash_2 = 0;
		this.fin_Cash_3 = 0;
		this.fin_Cash_4 = 0;
		this.fin_Cash_Max = 0;
		this.fin_Gearing_1 = 0;
		this.fin_Gearing_2 = 0;
		this.fin_Gearing_3 = 0;
		this.fin_Gearing_4 = 0;
		this.fin_Gearing_Max = 0;
	}
}

export class EhsConfigModel {
	ehs_CurrentYear: number;
	// ehs_Injury_Max					: number;
	// ehs_Injury_Yellow				: number;
	// ehs_Injury_Orange				: number;
	// ehs_Injury_CurrentYearValue		: number;
	// ehs_Injury_LastYearValue		: number;
	// ehs_Injury_Text					: string;
	// ehs_InjuryDays_Value			: number;
	// ehs_InjuryDays_TextExplanation	: string;
	// ehs_InjuryDays_TextPerformance	: string;
	// ehs_Process_Max					: number;
	// ehs_Process_Yellow				: number;
	// ehs_Process_Orange				: number;
	// ehs_Process_CurrentYearValue	: number;
	// ehs_Process_LastYearValue		: number;
	// ehs_Process_Text				: string;

	ehs_Injury_CurrentYearValue_Offshore: number;
	ehs_Injury_LastYearValue_Offshore: number;
	ehs_InjuryDays_LastDate_Offshore: Date = new Date();
	ehs_InjuryDays_BestPerformanceOffshore: number;
	ehs_Process_CurrentYearValue_Offshore: number;
	ehs_Process_LastYearValue_Offshore: number;
}

export class OpsMonthConfigModel {
	currentMonthName: string;
	CurrentYear: number;
}

export class OpsProductionAreaModel {
	ProdArea_OnshoreEA: number;
	ProdArea_OffshoreWA: number;
	ProdArea_OffshoreNA: number;
	ProdArea_PNG: number;
	ProdArea_Max: number;
}

export class OpsProductionTypeModel {
	ProdType_Domgas: number;
	ProdType_Liquids: number;
	ProdType_LNG: number;
	ProdType_Max: number;
}

export class OpsWellsDrilledandConnectedModel {
	Drilled_Cooper_Target: number;
	Drilled_Cooper_LastYear: number;
	Drilled_Cooper_Jan: number;
	Drilled_Cooper_Feb: number;
	Drilled_Cooper_Mar: number;
	Drilled_Cooper_Apr: number;
	Drilled_Cooper_May: number;
	Drilled_Cooper_Jun: number;
	Drilled_Cooper_Jul: number;
	Drilled_Cooper_Aug: number;
	Drilled_Cooper_Sep: number;
	Drilled_Cooper_Oct: number;
	Drilled_Cooper_Nov: number;
	Drilled_Cooper_Dec: number;
	Drilled_GLNG_Target: number;
	Drilled_GLNG_LastYear: number;
	Drilled_GLNG_Jan: number;
	Drilled_GLNG_Feb: number;
	Drilled_GLNG_Mar: number;
	Drilled_GLNG_Apr: number;
	Drilled_GLNG_May: number;
	Drilled_GLNG_Jun: number;
	Drilled_GLNG_Jul: number;
	Drilled_GLNG_Aug: number;
	Drilled_GLNG_Sep: number;
	Drilled_GLNG_Oct: number;
	Drilled_GLNG_Nov: number;
	Drilled_GLNG_Dec: number;
	Drilled_Max: number;
	Drilled_SubHeading: string;
}

export class OpsExplorationAndDrillingMilestonesModel {
	target: number;
	wellName: number;
	wellType: number;
	basin: number;
	status: number;
	sortOrder: string;
}

export class FinSalesRevenueModel {
	revenue_Name1: string;
	revenue_Name2: string;
	revenue_Name3: string;
	revenue_Name4: string;
	revenue_1: number;
	revenue_2: number;
	revenue_3: number;
	revenue_4: number;
	revenue_Max: number;
}

export class FinSUpstreamUnitProductionCostModel {
	cost_Name1: string;
	cost_Name2: string;
	cost_Name3: string;
	cost_Name4: string;
	cost_1: number;
	cost_2: number;
	cost_3: number;
	cost_4: number;
	cost_Max: number;
}

export class FinFreeCashFlowModel {
	cash_Name1: string;
	cash_Name2: string;
	cash_Name3: string;
	cash_Name4: string;
	cash_1: number;
	cash_2: number;
	cash_3: number;
	cash_4: number;
	cash_Max: number;
}

export class FinGearingModel {
	gearing_Name1: string;
	gearing_Name2: string;
	gearing_Name3: string;
	gearing_Name4: string;
	gearing_1: number;
	gearing_2: number;
	gearing_3: number;
	gearing_4: number;
	gearing_Max: number;
}